import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { tenantPickerFieldExtension } from './extensions/tenantPickerFieldExtension';
import { domainPickerFieldExtension } from './extensions/domainPickerFieldExtension';
import { systemPickerFieldExtension } from './extensions/systemPickerFieldExtension';
import { rdapFormSectionFieldExtension } from './extensions/rdapFormSectionFieldExtension';
import { logoUrlFieldExtension } from './extensions/logoUrlFieldExtension';
import { linksListFieldExtension } from './extensions/linksListFieldExtension';

export const rdapScaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    tenantPickerFieldExtension,
    domainPickerFieldExtension,
    systemPickerFieldExtension,
    rdapFormSectionFieldExtension,
    logoUrlFieldExtension,
    linksListFieldExtension,
  ],
});
